module.exports = __webpack_public_path__ + "static/media/recordatorioVacunacion.526e3d43.jpeg";